export enum SpaceKind {
  DATA_ROOM = 'data-room',
  VAULT = 'vault',
  WORKSPACE = 'workspace',
}

export enum SpaceErrorCode {
  DATA_ROOM_NAME_TAKEN = 'data-room-name-taken',
  FILE_NAME_TAKEN = 'file-name-taken',
  FOLDER_NAME_TAKEN = 'folder-name-taken',
  WORKSPACE_LIMIT_REACHED = 'workspace-limit-reached',
  WORKSPACE_NAME_TAKEN = 'workspace-name-taken',
}

export const LISTED_SPACE_KINDS = [SpaceKind.DATA_ROOM, SpaceKind.WORKSPACE] as const;

/** A space with its own folder tree and row — every kind except the company-wide Vault. */
export type TreeSpaceKind = Exclude<SpaceKind, SpaceKind.VAULT>;

export enum SpaceNodeKind {
  FILE = 'file',
  FOLDER = 'folder',
}

/** What a folder's contents or a search can be ordered by; the name order is the default. */
export enum SpaceNodeSortBy {
  LAST_EDIT = 'last-edit',
  NAME = 'name',
  SIZE = 'size',
}
